/**
 * Dynamic Video Section
 * Handles both external videos (YouTube/Vimeo) and uploaded video files
 */

class DynamicVideoSection {
  constructor(container) {
    this.container = container;
    this.videoElement = container.querySelector('[data-video="uploaded"]');

    if (this.videoElement) {
      this.init();
    }
  }

  init() {
    this.video = this.videoElement.querySelector('video');
    this.playButton = this.videoElement.querySelector('[data-video-play-button]');
    this.cover = this.videoElement.querySelector('[data-video-cover]');

    console.log('Video element:', this.video);
    console.log('Play button:', this.playButton);
    console.log('Cover:', this.cover);

    if (this.playButton && this.video) {
      this.playButton.addEventListener('click', this.handlePlayClick.bind(this));
      console.log('Play button click listener added');
    }

    // Handle video ended event to show cover again
    if (this.video) {
      this.video.addEventListener('ended', this.handleVideoEnded.bind(this));
    }
  }

  handlePlayClick(e) {
    e.preventDefault();
    console.log('Play button clicked');

    if (this.video.paused) {
      this.video.play().then(() => {
        console.log('Video playing');
        this.videoElement.classList.add('playing');
      }).catch(err => {
        console.error('Error playing video:', err);
      });
    } else {
      this.video.pause();
      this.videoElement.classList.remove('playing');
    }
  }

  handleVideoEnded() {
    this.videoElement.classList.remove('playing');
    this.video.currentTime = 0;
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, initializing video sections');
  const videoWrappers = document.querySelectorAll('.dynamic-video-wrapper');
  console.log('Found video wrappers:', videoWrappers.length);

  videoWrappers.forEach(wrapper => {
    new DynamicVideoSection(wrapper);
  });
});

// Shopify section events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const wrapper = event.target.querySelector('.dynamic-video-wrapper');
    if (wrapper) {
      new DynamicVideoSection(wrapper);
    }
  });
}
